import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import * as artifactActions from '~/artifact/actions';
import { StickyContainer, Sticky } from 'react-sticky';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import ArtifactHelper from '~/utils/ArtifactHelper';
import StringService from '~/utils/StringService';
import Helpers from '~/utils/Helpers';
import PermissionsHelper from '~/utils/PermissionsHelper';
import ArtifactHeader from '~/artifact/containers/ArtifactHeader';
import ArtifactView from '~/artifact/containers/ArtifactView';
import ArtifactLibraryList from '~/artifact/containers/ArtifactLibraryList';
import ArtifactViewMainContentCopyright from '~/artifact/components/ArtifactViewMainContentCopyright';
import Helmet from 'react-helmet';
import MetadataService from '~/utils/MetadataService';
import GenericCallToAction from '~/containers/GenericViewPaywall/genericCTAWithNoEmailInput';
import LoaderWrapper from '~/components/LoaderWrapper';
type ArtifactPageProps = {
  params: object;
  actions: object;
  artifactState: object;
  myState: object;
  orgState: object;
  location: object;
  vcPageState: object;
};
class ArtifactPage extends React.Component<ArtifactPageProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    this.props.actions.fetchArtifact(this.props.params.vulnId);
    this.props.actions.maybeUpdateArtifactActiveUrl(window.location.pathname);
    window.scrollTo(0, 0);
  }
  UNSAFE_componentWillUpdate(nextProps) {
    //redirect the user to /${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/security/:title/:language/sid-:vulnId from /${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/vulnerabilities/:vulnId
    const artifact = nextProps.artifactState.artifact;
    if (artifact.id) {
      if (
        this.props.location.pathname.startsWith(
          `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/vulnerabilities`
        )
      ) {
        const title = artifact.title ? artifact.title : artifact.description;
        const expectedPath = StringService.createSEOVulnItemUrl(
          title,
          artifact.language,
          artifact.id
        );
        this.props.actions.maybeUpdateArtifactActiveUrl(expectedPath);
        browserHistory.replace(expectedPath);
      }
    }
  }
  render() {
    const {
      myState,
      orgState,
      params,
      artifactState,
      vcPageState: { shouldShowVeracodePage },
    } = this.props;
    const { artifact = {} } = artifactState;
    const { title = '', artifactComponents: components = [] } = artifact;
    const isLoggedInAndPaidOrTrialing = PermissionsHelper.isLoggedInAndPaidOrTrialing(
      myState,
      orgState
    );
    const meta = MetadataService.generateVulnerabilityCatalogMeta(
      artifact,
      window.location.href,
      components
    );
    const isArtifactPremium = ArtifactHelper.isArtifactPremium(artifact);
    const showArtifactView = !isArtifactPremium || isLoggedInAndPaidOrTrialing;
    return (
      <div>
        <Helmet
          title={`${Helpers.sanitizeLanguageType(params.language)} - ${artifact.title}`}
          meta={meta}
        />

        <LoaderWrapper isLoaderShowing={!title} className="">
          <ArtifactHeader />
          <StickyContainer>
            <div className="grid mt">
              <div className="grid__item col-3-4">
                {showArtifactView ? <ArtifactView /> : <GenericCallToAction />}
              </div>
              <div className="col-1-4">
                <Sticky>
                  {({ style }) => (
                    <div style={style} className="">
                      <ArtifactLibraryList disableClick={!showArtifactView} />
                    </div>
                  )}
                </Sticky>
              </div>
            </div>
          </StickyContainer>
        </LoaderWrapper>
        {!shouldShowVeracodePage && <ArtifactViewMainContentCopyright />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
    orgState: state.orgState,
    routing: state.routing,
    vcPageState: state.vcPageState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactPage);
